import { BreadcrumbNavigation, Header } from "@/components";
import SeoHead from "@/components/SeoHead";
import { getRoute } from "@/functions/getRoute";

export default function ThankYouPage() {
  return (
    <div style={{padding: '150px 0'}}>
      <SeoHead
        page_name={`Thank you for Applying · EarthStream`}
        canonical_link={`https://www.earthstreamglobal.com/jobs/thank-you-for-applying`}
      />
      <Header
        back={{
          path: `page.home.component.Header.back`,
          placeholder: `Back to Home`,
          href: getRoute("home"),
        }}
        title={{
          path: `page.jobs.thank-you`,
          placeholder: "Thank you for submitting an enquiry",
        }}
        description={{
          path: `page.jobs.description`,
          placeholder: "Someone from our team will be in touch."
        }}
        img="/thank-you-for-enquiry.png"
      />
    </div>
  );
}
